import IconComputerMouseSolid from '@/assets/icons/font_awesome/computer-mouse-solid.svg?react';
import IconKeyboardSolid from '@/assets/icons/font_awesome/keyboard-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { PLACEHOLDER_BUTTON__BarGeneration } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_generation';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';

export function G_BUTTON__seed_hide_input() {
  /*
   * STORE
   */
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { user_settings } = use_slice_user(['user_settings']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const { generation_seeds_hide_input } = user_settings;

  const tooltip_title = t(
    generation_seeds_hide_input
      ? i18n_page_generation.sidebar_settings.setting.seed.button.hide_input.tooltip.title_show
      : i18n_page_generation.sidebar_settings.setting.seed.button.hide_input.tooltip.title_hide,
  );

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    const settings_new = user_settings.clone({ generation_seeds_hide_input: !generation_seeds_hide_input });

    await dispatch(REMOTE__user_settings_update(settings_new));
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * RENDERS
   */
  function render_icon() {
    return generation_seeds_hide_input ? IconKeyboardSolid : IconComputerMouseSolid;
  }

  /*
   * HTML
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_BUTTON__BarGeneration />;

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        Icon={render_icon()}
        iconClassNameBase={`text-component-item-foreground ${generation_seeds_hide_input ? 'size-4' : 'size-3'}`}
        iconClassNameHovered="!text-bar-foreground"
        size="rect-10-5"
        variant={'no-border-on-bar'}
        disabled={is_disabled()}
        renderDelay={CONSTANTS_TIME__client.MS_300}
        {...{ onClick }}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
